import { inject } from "@angular/core";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { catchError, exhaustMap, map, of, pipe } from "rxjs";
import { CommonApiService } from "src/app/services/common-api.service";
import { API } from "../../models/api.enum";
import { IAppState } from "../../models/app.model";
import { ILoginRes, ILoginSsoSaRes } from "../../models/login.models";

export type ILoginState = IAppState<ILoginRes | ILoginSsoSaRes>;

export const initialState: ILoginState = {
  data: null,
  isLoading: false,
  error: null,
};

export const SsoLoginStore = signalStore(
  withState(initialState),
  withMethods((store, apiService = inject(CommonApiService)) => ({
    ssoLogin: rxMethod<{ token: string; clientId: string }>(
      pipe(
        exhaustMap(({ token, clientId }) => {
          patchState(store, (state) => ({
            ...state,
            data: null,
            isLoading: true,
            error: null,
          }));
          return apiService
            .post<ILoginRes | ILoginSsoSaRes>(API.SSO_LOGIN, undefined, {
              jwtToken: token,
              clientId,
            })
            .pipe(
              map((data) =>
                patchState(store, (state) => ({
                  ...state,
                  data,
                  isLoading: false,
                }))
              ),
              catchError((error) => {
                return of(
                  patchState(store, (state) => ({
                    ...state,
                    data: null,
                    isLoading: false,
                    error: error,
                  }))
                );
              })
            );
        })
      )
    ),
    clearStore(): void {
      patchState(store, () => ({ ...initialState }));
    },
  }))
);
